/* eslint-disable react/no-danger */
import React from 'react';

import { env } from '@/common/config';

import {
  NEW_RELIC_INT_SNIPPET,
  NEW_RELIC_BETA_SNIPPET,
  NEW_RELIC_PROD_SNIPPET,
} from './newRelicSnippets';

const newRelicSnippets = {
  int: NEW_RELIC_INT_SNIPPET,
  beta: NEW_RELIC_BETA_SNIPPET,
  prod: NEW_RELIC_PROD_SNIPPET,
};

const NewRelicSnippet = newRelicSnippets[env];

const NewRelic = () => <script type="text/javascript" dangerouslySetInnerHTML={{ __html: NewRelicSnippet }} />;

export default NewRelic;
